import { createClient } from '@supabase/supabase-js'

// Sostituisci con i tuoi valori da Supabase > Project Settings > API
const SUPABASE_URL = 'https://rkhomglnrrsezpdrnzdy.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_DzUO2if9pL0e4slo4EUW8w_4tVIzHN7'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
